// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cart-item--upsell{background:#fff;padding:.75rem}.cart-item--upsell .cart-item__image{margin-right:var(--spacing);overflow:hidden;padding:0;position:relative;width:5rem}.cart-item--upsell .cart-item__image img{height:auto;left:50%;max-width:none;min-height:100%;min-width:100%;position:absolute;top:50%;transform:translate(-50%,-50%);width:auto}.cart-item--upsell .cart-item__price{line-height:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
